var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#354d9e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1033 -1099)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 21,
    transform: "translate(1033 1099)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035.625 1101.625)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 3.806,
    y1: 3.806,
    transform: "translate(11.944 11.944)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bbf989e8d261878d592163b5806a9272.svg";
export { ForwardRef as ReactComponent };